/**
* DevExpress Dashboard (_json-data-source.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { JsonSchemaRootNode } from '@devexpress/analytics-core/analytics-data';
import * as ko from 'knockout';
import { filter, PropertyCategory } from '../../metadata/_base-metadata';
import { dataSourceSerializationsInfo } from './_data-source';
export let jsonDataSourceSerializationsInfo = dataSourceSerializationsInfo.concat([
    filter,
    { propertyName: 'connectionName', modelName: '@ConnectionName' },
    { propertyName: 'rootElement', modelName: '@RootElement', defaultVal: 'root' },
    {
        propertyName: 'schema', modelName: 'Schema',
        from: (model, serializer) => ko.observable(JsonSchemaRootNode.from(model, serializer)),
        toJsonObject: JsonSchemaRootNode.toJson,
        category: PropertyCategory.NoUpdateByObservableValue
    },
    { propertyName: 'source', modelName: 'Source', defaultVal: '' },
]);
